/**
 * Quantity Stepper - Product Card ADD button and quantity steppers.
 *
 * @template <quantity-stepper>
 */
import { Component, Injectable, Input, OnInit, OnChanges, Output, EventEmitter, ElementRef, OnDestroy, NgZone, HostListener, SimpleChanges } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject, Subscription } from 'rxjs';

// Data model
import { ProductModel, ISnsInfoObj, ICart , IConfigObj} from 'abs-ngx-library/src/lib/core';
import { CommonService, ABTestService , UserInfoService , CartService , CartV2Service , UtilService, ProductUtilService } from 'abs-ngx-library/src/lib/core';

import { EnviormentConfig, AemService } from 'abs-ngx-library/src/lib/core';


import { debounceTime, map, tap } from 'rxjs/operators';
import { ToasterALV1Service } from 'abs-ngx-library/src/lib/toaster-al';
import { ToasterType } from 'abs-ngx-library/src/lib/toaster-al';
import { ProductSNSModalALService } from '../product-sns-modal-al/product-sns-modal-al.service';
import { QuickAddBasketV1Service } from 'abs-ngx-library/src/lib/core';

// jQuery
declare let $: any;

@Component({
  selector: 'quantity-stepper-al-v1',
  templateUrl: './quantity-stepper-al-v1.component.html',
  styleUrls: ['./quantity-stepper-al-v1.component.scss']
})

@Injectable()
export class QuantityStepperALV1Component implements OnInit, OnChanges, OnDestroy {
    @HostListener('window:click', ['$event'])
    onQscClick(event) {
        if (!this.isQscV2 || !this.isQuantityStepperExtended) {
            return;
        }

        // if(!document.querySelector(`#addButton_${this.product.id}`)?.contains(event.currentTarget)) {
        //     this.isQuantityStepperExtended = false;
        //     if (this.updateState.show) {
        //         this.updateState.show = false;
        //     }
        // }
        // Close stepper only if clicking on element not in stepper.
        if (!event.target.closest(`#addButton_${this.product.id}`)) {
            if (!event.target.closest(`div.product-btn__update`)) {
                this.isQuantityStepperExtended = false;
                if (this.updateState.show) {
                    this.updateState.show = false;
                }
            }
        }
    }

    @Input() product: ProductModel;
    @Input() products: ProductModel[];
    @Input() calledBy: string;
    @Input() componentInfo: string;
    @Input() carouselTitle: any;
    @Input() carouselId: number;
    @Input() mainIngredient: any;
    @Input() isRecommended: boolean;
    @Input() crossSellEnabled: boolean;
    @Input() crossSellType: string;
    @Input() isAnyProductHasAddlInfo: boolean;
    @Input() isBIA: boolean;
    @Input() pathwaysWidget: any;
    @Input() isMarketPlaceEnabled: boolean = false;
    @Input() isWineShopEnabled: boolean = false;
    @Input() isQscV2: boolean;

    @Input()
    set isCheckboxChecked(state: boolean) {
        this._isCheckboxChecked = state;
        if (!this._isCheckboxChecked) {
            this.isQuantityStepperExtended = false;
            this.updateState.show = false;
        }
    }
    @Input() snsInfo?: ISnsInfoObj;
    @Input() isMkpSellerTagDisabled: boolean;
    
    @Input() configObj: IConfigObj;

    @Output() onQtyUpdate = new EventEmitter<Object>();
    @Output() removePastPurchasesEmitter = new EventEmitter<Object>();
    @Output() removeMiniCartEmitter = new EventEmitter<Object>();
    @Output() changeMiniCartEmitter = new EventEmitter<Object>();
    @Output() updateUnavailableCountEmitter = new EventEmitter<Object>();
    @Output() updateCheckboxEmitter = new EventEmitter<boolean>();
    // Used to trigger recalculating quick add basket total qty on BiaGrid.
    @Output() updateQscQtyEmitter = new EventEmitter();

    // DFTA - wcax env config
    private config = EnviormentConfig;

    private quantityChange = new Subject<any>();
    private quantityChange$ = this.quantityChange.asObservable();
    private snsInfoChange = new Subject<any>();
    private snsInfoChange$ = this.snsInfoChange.asObservable();
    private cartLSname = 'abCart';
    private addToCartEndpoint: string = window['AB']['addToCartPath'];
    public ADD = 'Add';
    public SIGNIN = 'Sign in to add';
    public SIGNIN_LIGHT = 'Sign in';
    private isWYSIWYGEnabled: boolean;
    private isPrebookRedirect: boolean;
    private allProductsToAdd: any;
    private updateBiaAddAllSubscription: Subscription;
    private subscriptions: Subscription = new Subscription();
    //private _isPromiseServiceEnabled = window['SWY']['CONFIGSERVICE']['featureToggleConfig']['isPromiseServiceEnabled'];
    private _isPromiseServiceEnabled = true;
    private _disableSubPromptFlag = window['SWY']['CONFIGSERVICE']
        && window['SWY']['CONFIGSERVICE'].featureToggleConfig
        && window['SWY']['CONFIGSERVICE'].featureToggleConfig.hasOwnProperty('disableSubPromptFlag')
            ? window['SWY']['CONFIGSERVICE'].featureToggleConfig.disableSubPromptFlag
            : true;
    private addItemToCartAnalytics: boolean;
    private increaseQuantityAnalytics: boolean;
    private decreaseQuantityAnalytics: boolean;
    private removeItemFromCartAnalytics: boolean;
    private analyticsPreviousPrice;
    private analyticsIsPriceDecreased: boolean;
    public _isCheckboxChecked: boolean;

    public statusAriaLive = 'off';
    public statusAddAriaMessage = '';
    public statusQuantityUpdate = '';
    public quantityMessage = '';
    public quantityAriaLabelMessage = '';
    public quantityAdaMessage = '';
    public loadingSpinner: boolean = false;
    public checkMark: boolean = false;
    public productDetailPath: string;
    public isArEnable: boolean = false;
    public updateState: any = {
        show: false,
        input: null,
        button: 'Update'
    };
    public httpOptions;

    public cartId;
    public _cartIdCreated = new Subject<any>();
    public cartIdCreated$ = this._cartIdCreated.asObservable();

    public orderNumber;
    public showQtyUpdateBtn: boolean = false;
    public isAuthorized: boolean = false;
    public isV2CarouselItem: boolean = false;
    public isV2ProductItem: boolean = false;
    public isCrossSellProductItem: boolean = false;
    public isBiaAddAll: any = '';
    public disableAddAll = false;
    public reservedTimeIntent: string = '';
    public mto = {
        popup: {
            show: false,
            closeBtn: '.mto-popup__close-btn',
            modalId: '#mtoModal',
            firstFocusableElem: '.mto-popup__close-btn',
            lastFocusableElem: '.mto-popup__dont-add-btn'
        },
        error: {
            show: false,
            closeBtn: '.mto-popup-error__close-btn',
            modalId: '#mtoModalError',
            firstFocusableElem: '.mto-popup-error__close-btn',
            lastFocusableElem: '.mto-popup-error__close-btn'
        }
    };
    public isThemeBuilderEnabled : boolean;
    public toastMessagePostion: string = '20vh';
    public addAllProductsMessage: string = '';
    public noOfProductsToAdd: number;
    public currentEnv = '';
    public baseDomainUrl = '';
    public isOnProductDetail: boolean = false;
    private hasCart: boolean;

    // States can be default, extended, disabled.
    private quantityStepperState: string;
    // Extends when user clicks on the quantity stepper.
    public isQuantityStepperExtended: boolean = false;
    public qscQuantity: number;
    private preventFocusOnQty: boolean;
    public stepperAnnouncement: string;
    // @@TODO - how to handle ?
    //private isMarketPlaceR2Disabled = window['SWY']['CONFIGSERVICE']['featureToggleConfig']['isMarketPlaceR2Disabled'] === false ? false : true;
    private isMarketPlaceR2Disabled = true;
    private enableAdRelevanceTracking: boolean;
    public changeLabel: string;
    public contents: any;
    public isLightWeightProduct: boolean = false;
    public isQuantityIncreased: boolean = false;
    private entryId: number;

    public constructor(private _zone: NgZone,
        private _abTestService: ABTestService,
        private _commonService: CommonService,
        private _userInfoService: UserInfoService,
        private _elementRef: ElementRef,
        public toasterService: ToasterALV1Service,
        private cartService: CartService,
        private _http: HttpClient,
        private _utilService : UtilService,
        private cartV2Service: CartV2Service,
        private _productUtilService: ProductUtilService,
        private _aemService: AemService,
        private _productSnsModalService: ProductSNSModalALService,
        private _quickAddBasketService: QuickAddBasketV1Service,
    ) {
        this.isAuthorized = this._userInfoService.isAuthorized();
        this.reservedTimeIntent = this._userInfoService.getUserChannel();
        this.currentEnv = this._commonService.getCurrentEnviorment();
        this.baseDomainUrl = this.config[this.currentEnv]?.baseURL?.replace("{banner}", this._userInfoService.getBanner());
        this.enableAdRelevanceTracking =  !this._aemService.getFeatureFlagByNameDisable('disableAdRelevance');

    }

    public ngOnInit(): void {
        this.isOnProductDetail = this.calledBy === 'product-detail-item';
        this.isLightWeightProduct = this.calledBy === 'light-weight';
        const productCarouselItemV2Wrapper = $(this._elementRef.nativeElement).closest('product-carousel-item-al-v1');
        this.isV2CarouselItem = productCarouselItemV2Wrapper.length ? true : false;
        const productItemV2Wrapper = $(this._elementRef.nativeElement).closest('product-item-al-v1');
        this.isV2ProductItem = productItemV2Wrapper.length ? true : false;
        const crossSellproductItem = $(this._elementRef.nativeElement).closest('.cross-sell__product');
        this.isCrossSellProductItem = crossSellproductItem.length ? true : false;
        this.isBiaAddAll = this.calledBy === 'biaAddAllBtn';
        this.orderNumber = this._aemService.getOrderNumberCookie();

        if (this.isQscV2) {
            this.quantityStepperState = this._isCheckboxChecked ? 'default' : 'disabled'
            this.qscQuantity = JSON.parse(localStorage.getItem('quickAddBasket')).cartItemsList.find((item) => (item.itemId == this.product.id)).qty;
            // Watch the cart for any changes, keeping the state constant between localStorage quickAddBasket and user's cart.
            const cartObjSubscription = this._commonService.currentCartObj.subscribe((cartObj) => {
                // If the cart has the same item as an item in localStorage, then update it to the val in cart.
                const matchingItem = cartObj?.cartItems?.find(item => item.itemId == this.product.id);
                if (matchingItem) {
                    this.qscQuantity = matchingItem.qty;
                    this.setLocalStorageQscQuantity(this.qscQuantity);
                }
            });
            this.subscriptions.add(cartObjSubscription);
        }

        if (this.calledBy === 'biaAddAllBtn') {
            this.updateBiaAddAllBtnContext();

            /**
             * Subscription to update bia add all button. This will determine how many products
             * need to be added to the cart if the user decides to add some items individually
             * then later decides to use the add all button
             **/
            this.updateBiaAddAllSubscription = this._commonService.updateBiaAddAllBtn$.subscribe((update) => {
                if (update) {
                    this.updateBiaAddAllBtnContext();
                }
            });
        }

        if (this._isRegistered()) {
            if (this._commonService.checkCartId('cartId')) {
                this.cartId = this._commonService.getCartId('cartId');
            }
        } else {
            if (this._commonService.checkCartId('guestCartId')) {
                this.cartId = this._commonService.getCartId('guestCartId');
            }
        }

        if (this._isRegistered()) {
            this.httpOptions = {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this._userInfoService.getSWY_SHOP_TOKEN(),
                    'Sort-Order': 'date',
                    'ocp-apim-subscription-key': this.config[this.currentEnv].cartAPIDetails.subscriptionKey.value,
                    //'ocp-apim-trace': window['AB']['cartapimtrace']
                    'ocp-apim-trace': 'true'
                })
            };
        } else {
            this.httpOptions = {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Sort-Order': 'date',
                    'ocp-apim-subscription-key': this.config[this.currentEnv].cartAPIDetails.subscriptionKey.value,
                    'ocp-apim-trace': 'true'
                })
            };
        }

        if (!this.isBiaAddAll) {
            // DNF page does not redirect to PDP page
            //this.productDetailPath = this._appConfigService.getProductDetailPath();

            if (this.productDetailPath) {
                this.productDetailPath = this.productDetailPath.replace('(bpn)', (this.product.id !== undefined)
                    ? this.product.id
                    : this.product.itemId);
            }

            this.product['originalQuantity'] = this.product.quantity;
        }

        if (this.calledBy === 'lastorder') {
            this.product.quantityOrder = this.product.previousPurchaseQty ? this.product.previousPurchaseQty : this.product.quantity;
        }

        if (this.calledBy !== 'minicart' && !this.isBiaAddAll) {
            let obs = this._commonService.currentCartObj;
            const cartName = this.cartV2Service.getCartName(this.configObj?.programType, this.product.sellerId);

            obs = obs.pipe(map(objCart => this.cartV2Service.fetchCartDetailsFromResponse(objCart, cartName)));

            obs.subscribe(objCart => {
                this.hasCart = !!objCart.cartId;

                let qty: any = 0;

                try {
                    let cartProduct: any = {};

                    if (!this._commonService.checkPendingOrder()) {
                        cartProduct = objCart?.['cartItems']?.find(item => item.itemId == this.product.id);
                        qty = cartProduct ? cartProduct.qty : 0;
                    } else {
                        cartProduct = objCart?.['cartItems']?.find(item => item.itemId == this.product.id);
                        qty = cartProduct ? cartProduct.quantity : 0;
                    }

                    this.product.maxPurchaseQty = cartProduct.maxPurchaseQty;
                    this.entryId = cartProduct?.entryId;

                    qty = (qty > 0) ? qty : 0;

                } catch (e) {
                    qty = 0;
                }

                this.product.quantity = qty;
                this.quantityMessage = this._getQuantityMessage();

                if(this.calledBy == 'snsCheckoutFlowModal'){
                    this.qscQuantity = 1;
                    this.quantityMessage = this.qscQuantity.toString();
                    this.quantityAriaLabelMessage = '1' + ' units of ' + this.product.name;
                }

                // product from last order carousel/page which is in current cart
                if (this.calledBy === 'lastorder' && this.product.quantityOrder > 0 && this.product.quantity > 0) {
                    this.updateState = {
                        show: false,
                        input: null,
                        button: 'Update'
                    };
                }
            });
        }

        // Product from last order carousel/page which is not in current cart.
        if (this.calledBy === 'lastorder' && this.product.quantityOrder > 0 && this.product.quantity < 1) {

            const inputQuantity =
                this.product.hasOwnProperty('maxPurchaseQty')
                && this.product.maxPurchaseQty
                && this.product.quantityOrder > this.product.maxPurchaseQty
                    ? this.product.maxPurchaseQty : this.product.quantityOrder;

            this.product.quantityOrder = inputQuantity;
            if (inputQuantity > 0) {
                this.updateState = {
                    show: true,
                    input: this.product.quantityOrder,
                    button: 'Add'
                };
            }
        }

        // Debounce 600ms before sending data to API.
        this.quantityChange$
            .pipe(
                tap((qty) => this.updateLoadingMessage(qty)),
                debounceTime(600)
            )
            .subscribe(qty => {
                if (!this.isBiaAddAll) {
                    this.loadingSpinner = true;
                    this.addCart(qty);
                } else {
                    this.addAllItemsToCart(qty);
                }
            });

        // Debounce 600ms before sending data to API.
        this.snsInfoChange$.pipe(
            debounceTime(600)
        ).subscribe(snsInfoObj => {
            this._cartAPICallV2(snsInfoObj.qty, snsInfoObj.snsInfo);
        });

        if (this._commonService.checkPendingOrder()) {
            this.reservedTimeIntent = JSON.parse(localStorage.getItem('abSlotEditOrder'))?.serviceType;
        } else {
            this.reservedTimeIntent = JSON.parse(localStorage.getItem('abSlot'))?.userChannel;
        }
        // add first time cart modal listeners
        this.addFirstTimeCartModalListeners();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        
        if(this.isOnProductDetail && this.snsInfo.isChecked){
            this.contents = this._productSnsModalService.getDynamicContents();
            this.changeLabel = this.contents?.snsSubscribedCTAText;
        } else {
            this.changeLabel = 'Add';
        }
        this.isBiaAddAll = this.calledBy === 'biaAddAllBtn';
        /*
         * README: Update quantity message when the product data change is triggered from an external source.
         * eg. This gets triggered when the product is swapped in meals-product-grid.
         */
        if (!this.isBiaAddAll) {
            if (this.calledBy === 'minicart') {
                this.quantityMessage = this._getQuantityMessage(this.product.qty);
            } else {
                this.quantityMessage = this._getQuantityMessage(this.product.quantity);
            }
        }

        if(changes.snsInfo && changes.snsInfo.currentValue.updateCart) {
            const qty = this.calledBy === 'minicart' ? this.product.qty : this.product.quantity;
            if(qty > 0) {
                this.snsInfoChange.next({qty: qty, snsInfo: changes.snsInfo});
            }   
        }
    }

    /**
     * Add current product in cart.
     *
     * @param {any} quantity New stepper's quantity.
     */
    public addCart(quantity?: any): void {
        quantity = (quantity >= 0) ? quantity : 0;

        if (this.product.maxPurchaseQty && quantity > this.product.maxPurchaseQty) {
            quantity = this.product.maxPurchaseQty;
        }

        if (quantity === 0 && this.calledBy === 'minicart') {
            // Remove product from minicart
            this._removeMiniCart();
            this.statusAriaLive = 'polite';
        } else {
            if (quantity === 0) {
                this._removeProductV2();
            } else {

                // Send data to API to sync mini cart
                this.showQtyUpdateBtn = true;
                this.quantityMessage = this._getQuantityMessage(quantity);
                    this._cartAPICallV2(quantity);

                if (this.statusQuantityUpdate === 'increase') {
                    this.isQuantityIncreased = true;
                    this.statusAddAriaMessage = '1 item added to cart';

                } else if (this.statusQuantityUpdate === 'decrease') {
                    this.statusAddAriaMessage = '1 item removed from cart';

                } else if (this.statusQuantityUpdate === 'update') {
                    this.statusAddAriaMessage = 'cart updated';

                } else {
                    this.statusAddAriaMessage = '';
                }
            }
        }
    }

    public showPriceChangeToast(isQuantityIncreased: boolean, cart: any) {
        if (isQuantityIncreased && this._commonService.checkPendingOrder()) {
            const orderedProduct = cart['cartItems']?.find(item => item.itemId === this.product.id);
            const price = this._commonService.getValidProductPrice(this.product);
            const orderedItemPrice = orderedProduct?.price < orderedProduct?.basePrice ? orderedProduct?.price : orderedProduct?.basePrice;
            if (orderedProduct && orderedItemPrice !== price) {
                let msg = `Great news—your price for this item is still $${orderedItemPrice}, based on when you placed your order. `;
                this.analyticsPreviousPrice = orderedItemPrice;
                if (orderedItemPrice > price) {
                    msg = `The price for ${this.product.name} has changed, but your price is still $${orderedItemPrice} based on its price on the day your order was placed. `;
                    this.analyticsIsPriceDecreased = true;
                }
                this.toasterService.show({
                    title: 'OK',
                    message: msg,
                    type: ToasterType.Info,
                    interactiveElement: 'See Policy',
                    interactiveElementLink: 'https://www.albertsonscompanies.com/policies-and-disclosures/terms-of-use/default.aspx',
                }, { class: 'popup--toaster--right'});
            }
        }
    }

    public beforeIncreaseCart(crossSell: boolean, redirectToPrebook?: boolean): void {
        console.warn('beforeIncreaseCart()');
        let bpn;

        this.isPrebookRedirect = redirectToPrebook ? redirectToPrebook : false;

        if (!this.isBiaAddAll) {
            bpn = (this.product.id !== undefined) ? this.product.id : this.product.itemId;
        }

        const preference = this._userInfoService.getPreference()
            ? this._userInfoService.getPreference().toUpperCase()
            : undefined;

        if (this.isAuthorized) {
            // README: wrapping the entire code as anonymous function to pass it as a callback Function
            const increaseCartIfSessionValid = () => {
                console.warn('increaseCartIfSessionValid()');

                if (preference === 'DELIVERY' || preference === 'DUG') {
                    if(this.calledBy != 'snsCheckoutFlowModal') {
                    this.increaseCart();
                    }
                    if (crossSell && this.calledBy !== 'crosssell') {
                        if (localStorage.getItem('abCart')) {
                            const productIds = this.cartService._get()['cartItems'].map(product => product.itemId);
                            this._commonService.showCrossSell(bpn, this.product.aisleId, productIds, this.crossSellType);
                        } else {
                            this._commonService.showCrossSell(bpn, this.product.aisleId, [], this.crossSellType);
                        }
                    }
                } else {
                    if (preference === 'J4U') {
                        if(this.configObj?.appName==='weeklyAd'){
                            this.navigateBannerDomainToOpenStoreSlctChange();
                        }else{
                            window['rightDrawerComp'].closeDrawer();
                            if (window['AB'] && window['AB']['DATALAYER']) {
                                window['AB']['DATALAYER'].analyticsCTATracking(`cta:${window['AB']['DATALAYER'].pathSections.join(':')}|link|add-to-cart`);
                            }
                            window['storeFulfillmentModal'].component.setModalDisplayData(2);
                        }
                    }
                }

                if (this.calledBy != 'snsCheckoutFlowModal') {
                $('.delivery-content__button, .pickup-content .card-store-btn').click(() => {
                    this.increaseCart();
                });
                } else {
                    if(this.qscQuantity < Number(this.product.maxPurchaseQty) ){
                        this.qscQuantity += 1;
                        this.quantityAriaLabelMessage = this.qscQuantity.toString() + ' units of ' + this.product.name;
                        this.quantityMessage = this.qscQuantity.toString();
                        setTimeout(() => $(this._elementRef.nativeElement).children().find("span#qtyInfo_" + this.product.id).focus(), 0);
                        this.updateQscQtyEmitter.emit(this.quantityMessage);
                    }
                }
            };

            // README: calling validateSession with a callback function (i.e increaseCartIfSessionValid) which does check for
            // a valid session and increase the cart
            if (this._commonService.isGuestUser()) {
                increaseCartIfSessionValid();
            } else {
                this._commonService.validateSession(increaseCartIfSessionValid);
            }
        } else {
            if (window['eddlLoadComplete']) {
                window['AB']['DATALAYER'].setATCFlag(true);
            }
            this._showSignInModal(this.configObj);
        }
    }

    /**
     * Increase current product quantity in cart.
     */
    public increaseCart(): void {
        console.warn('increaseCart()');
        const refocusButton = event ? event.currentTarget : null;
        const preference = this._userInfoService.getPreference()
            ? this._userInfoService.getPreference().toUpperCase()
            : undefined;

        if (preference === 'J4U') {
            if(this.configObj.appName==='weeklyAd'){
                this.navigateBannerDomainToOpenStoreSlctChange(); 
            } else {
                window['storeFulfillmentModal'].component.setModalDisplayData(2);
            }

        } else {

            let isAddedToCart = false;

            if (this.calledBy === 'minicart') {
                this.product.qty = this.product.qty + 1;

                if (this.product.qty === 1) {
                    this.loadingSpinner = true;
                    isAddedToCart = true;
                }
                this.quantityMessage = this._getQuantityMessage(this.product.qty);
                this.quantityChange.next(this.product.qty);
            } else if (!this.isBiaAddAll) {
                this.product.quantity = this.product.quantity ? this.product.quantity + 1 : 1;
                if (this.product.quantity === 1) {
                    this.loadingSpinner = true;
                    isAddedToCart = true;
                }
                this.quantityMessage = this._getQuantityMessage(this.product.quantity);
                this.quantityChange.next(this.product.quantity);
            } else {
                console.warn('isBiaAddAll');
                isAddedToCart = true;
                this.quantityChange.next(this.addAllItemsMap());
            }

            this.statusAriaLive = 'polite';
            this.statusQuantityUpdate = 'increase';

            if (!this.isBiaAddAll) {
                if (isAddedToCart) {
                    this.addItemToCartAnalytics = true;
                    this.setAnalyticsSNSProdAction('add-item');
                } else {
                    this.increaseQuantityAnalytics = true;
                    this.setAnalyticsSNSProdAction('quantity-increase');
                    this.setFocusBackOnButton(refocusButton);
                }
            }
        }
    }

    /**
     * Decrease current product quantity in cart.
     */
    public decreaseCart(): void {
        const preference = this._userInfoService.getPreference()
            ? this._userInfoService.getPreference().toUpperCase()
            : undefined;

        if (preference === 'J4U') {
            if(this.configObj.appName==='weeklyAd'){
                this.navigateBannerDomainToOpenStoreSlctChange(); 
            } else {
            window['storeFulfillmentModal'].component.setModalDisplayData(2);
            }

        } else {

            if (this.isAuthorized) {
                // README: wrapping the entire code as anonymous function to pass it as a callback Function
                const decreaseCartIfSessionValid = () => {
                    if (this.calledBy === 'minicart') {
                        this.product.qty = this.product.qty - 1;

                        if (this.product.qty === 0) {
                            this.loadingSpinner = true;
                            this._commonService.closeCrossSell(this.product.id);
                        }

                        this.quantityMessage = this._getQuantityMessage(this.product.qty);
                        this.quantityChange.next(this.product.qty);

                    } else if(this.calledBy === 'snsCheckoutFlowModal') {
                        if (this.qscQuantity == 1) {
                            this.quantityAriaLabelMessage = '1' + ' units of ' + this.product.name;
                            return;
                        } else {
                            this.qscQuantity -= 1;
                            this.quantityAriaLabelMessage = this.qscQuantity.toString() + ' units of ' + this.product.name;
                            this.quantityMessage = this.qscQuantity.toString();
                            setTimeout(() => $(this._elementRef.nativeElement).children().find("span#qtyInfo_" + this.product.id).focus(), 0);
                            this.updateQscQtyEmitter.emit(this.quantityMessage);
                        }

                    } else {
                        this.product.quantity = this.product.quantity - 1;

                        if (this.product.quantity === 0) {
                            this.loadingSpinner = true;
                            setTimeout(() => {
                                $('#addButton_' + this.product.id).focus();
                            }, 150);

                            this._commonService.closeCrossSell(this.product.id);
                        }

                        this.quantityMessage = this._getQuantityMessage(this.product.quantity);
                        this.quantityChange.next(this.product.quantity);
                    }

                    const refocusButton = event ? event.currentTarget : null;

                    this.statusAriaLive = 'polite';
                    this.statusQuantityUpdate = 'decrease';

                    if ((this.product.quantity === 0) || (this.product.qty === 0)) {
                        if (this.calledBy !== 'minicart' && window['AB']['DATALAYER']) {
                            this.removeItemFromCartAnalytics = true;
                            this.setAnalyticsSNSProdAction('remove-item');
                        }
                    } else {
                        this.decreaseQuantityAnalytics = true;
                        this.setAnalyticsSNSProdAction('quantity-decrease');
                        this.setFocusBackOnButton(refocusButton);
                    }
                };

                // README: calling validateSession with a callback function (i.e decreaseCartIfSessionValid) which does check for
                // a valid session and decrease the cart
                if (this._commonService.isGuestUser()) {
                    decreaseCartIfSessionValid();
                } else {
                    this._commonService.validateSession(decreaseCartIfSessionValid);
                }

            } else {
                this._showSignInModal();
            }
        }
    }

    private setFocusBackOnButton(refocusButton: any) {
        setTimeout(() => {
            $(refocusButton).focus();
        }, 8500);
    }

    public getProductFullName() {
        let fullName = '';

        if (this.product)
            fullName = this.product.fullName && this.product.fullName.length ? this.product.fullName : this.product.name;

        return fullName;
    }

    /**
     * Update analytics product info.
     */
    private _updateAnalyticsProductInfo(sellerId?): void {
        // check for datalayer availability, in case component is loaded on pages without the AEM datalayer
        if (window['AB']?.DATALAYER) {
            // determine whether the current stepper is on a product that is part of the cross-sell component
            const isCrossSell = this._elementRef.nativeElement.closest('cross-sell') ? true : false;
            const isBIACrossSell = this._elementRef.nativeElement.closest('.slick-product-carousel')?.querySelectorAll('[data-carousel-behaviour="bia-crossSell"]')?.length;
            const isBIASpaCarousel = this._elementRef.nativeElement.closest('.slick-product-carousel')?.querySelectorAll('[data-carousel-behaviour="bia-spaCarousel"]')?.length;
            let carouselTitle = '';
            if (this.carouselTitle) {
                carouselTitle = this.carouselTitle;
            } else if (isBIACrossSell) {
                carouselTitle = this._elementRef.nativeElement.closest('cross-sell')?.querySelector('.cross-sell__header .cross-sell__title')?.textContent;
            } else if (isBIASpaCarousel) {
                carouselTitle = this._elementRef.nativeElement.closest('.bia-spa-carousel-container')?.querySelector('.bia-spa-carousel-container-header')?.textContent?.trim();
            } else if (this._elementRef.nativeElement.closest('.master-product-carousel')) {
                carouselTitle = this._elementRef.nativeElement.closest('.master-product-carousel').querySelector('[data-carousel-title]')?.getAttribute('data-carousel-title');
            } else if (window['AB'].DATALAYER.isDFTAPage()) {
                carouselTitle = this._elementRef.nativeElement.closest('.slick-product-carousel')?.previousElementSibling?.textContent?.trim() || '';
            } else {
                carouselTitle = this._elementRef.nativeElement.closest('.slick-product-carousel')?.querySelector('lazy-wrapper')?.getAttribute('data-carousel-title') || 
                this._elementRef.nativeElement.closest('.slick-product-carousel')?.querySelector('.carousel-header-text')?.textContent?.trim() || this._elementRef.nativeElement.closest('.slick-product-carousel')?.querySelector('targeted-wrapper')?.getAttribute('data-carousel-title');
            }

            const productInfoObj: any = {
                id: this.product.id || this.product.itemId,
                adobeMetricA: this.product['adobeMetrics']?.metricA,
                adobeMetricC: this.product['adobeMetrics']?.metricC,
                fullName: this.product.fullName,
                name: this.product.name,
                units: this._commonService.checkPendingOrder() ? this.product.quantity : this.product.qty,
                unitType: this.product.unitQuantity,
                lbs: '0',
                each: '0',
                pricePerUnit: this.product.pricePer,
                listPrice: this.product.price ? this.product.price.toString() : '',
                carouselSection: carouselTitle,
                basePrice: this.product.basePrice ? this.product.basePrice.toString() : '',
                pricingType: this.product.promoType,
                couponFlag: '0',
                couponClipped: '0',
                couponID: '',
                aisleId: this.product.aisleId,
                upc: this.product.upc,
                isCrossSell: isCrossSell,
                isMTO: this.product.isMtoProduct,
                departmentName: this.product.departmentName,
                pathwaysWidget: this.pathwaysWidget,
                sellerId: sellerId ? sellerId : this.product.sellerId,
                sellerName: this.product['sellerName'],
                editOrderFlow: this._commonService.checkPendingOrder() ? true : false,
                snapEligible: this.product.snapEligible,
                isProductTrackingDisabled: this.product.isProductTrackingDisabled ? true : false,
                isP13nGrid: this._elementRef.nativeElement.closest('#p13nProductGrid') ? true : false,
                quantity: this.product.quantity,
                previousPrice: this.analyticsPreviousPrice,
                isPriceDecreased: this.analyticsIsPriceDecreased,
                badges: this.product.badges,
                containsAlcohol: this.product.containsAlcohol,
                featured: this.product.featured
            };
            if (this.product.unitQuantity == 'EACH') {
                productInfoObj.each = this.product.quantity ? this.product.quantity.toString() : this.product.qty?.toString();
            }

            //TODO: Analytics team should make changes here to not consume coupons from local storage
            const coupons = [];
            // If there are coupons present on the product, filters the information and adds it to the productInfo object
            if (coupons.length > 0) {
                const couponsClipped = coupons.filter(x => x.status === 'C').length;
                const couponsCount = coupons.length;
                const couponIds = coupons.filter(x => x.status === 'C').map(x => x.offerId).toString();

                productInfoObj.couponFlag = couponsCount.toString();
                productInfoObj.couponClipped = couponsClipped.toString();
                productInfoObj.couponID = couponIds;
            }

            // For items that are not on the minicart, set the recommendation type to be used in analytics code
            if (this.calledBy !== 'minicart') {
                let isBuyItAgain;
                let isBrPathway;
                let isPicksForYou = false;
                let isP13nGeneric = false;
                if (carouselTitle) {
                    const parentCarousel = $(this._elementRef.nativeElement).closest('.slick-product-carousel');
                    const buyItAgainCarousel = parentCarousel.find('[data-carousel-behaviour=buy-it-again]').length;
                    const brPathwayCarousel = parentCarousel.find('[data-carousel-driven=pathway-search]').length;
                    const p13nGenericCarousel = parentCarousel.find('[data-carousel-driven=p13n-generic]').length;
                    productInfoObj.isBIACarousalProduct = parentCarousel.find('[data-carousel-behaviour=bia-spaCarousel]').length ? true : false;
                    isBuyItAgain = buyItAgainCarousel ? true : false;
                    isBrPathway = brPathwayCarousel ? true : false;
                    isPicksForYou = carouselTitle.search(/picks for you|picked for you|picks-for-you|picked-for-you/i) !== -1;
                    isP13nGeneric = p13nGenericCarousel ? true : false;
                    // set placement value for carousel items
                    productInfoObj.placement = window['AB'].DATALAYER.setPlacementInfoCarouselItems(this._elementRef.nativeElement);
                }
                const recommendationObj = {
                    isCrossSell: isCrossSell,
                    isRecommended: this.isRecommended || isPicksForYou || isP13nGeneric,
                    isSponsored: this.product['featured'],
                    isPastPurchased: isBuyItAgain || this.product['pastPurchased'],
                    isBrPathway: isBrPathway
                };
                if (this.product['adId'] || this.product.eventTracking) {
                    recommendationObj.isSponsored = true;
                }
                window['AB'].DATALAYER.recommendationInfo(recommendationObj);
            }
            window['AB'].DATALAYER.productInfo(productInfoObj);

            /**
             * update pageFilter with:
             * cart type (when a user performs a product action in mini cart)
             * carousel title (when a user performs any action related to a carousel)
             */
            if (this.calledBy === 'minicart') {
                window['AB'].DATALAYER.setCarouselName('shop|mini_cart');
            } else if (carouselTitle) {
                window['AB'].DATALAYER.isRecipesPage()
                    ? window['AB'].DATALAYER.setCarouselName(`recipes|${carouselTitle}`)
                    : window['AB'].DATALAYER.setCarouselName(`shop|${carouselTitle}`);
            } else {
                window['AB'].DATALAYER.setCarouselName('');
            }

            /**
             * for products that are not in the minicart or in a carousel
             * set metaInfo(number of images clicked on pdp before the user performs a product action)
             */
            if (window['AB'].DATALAYER.isPdp()) {
                if (this.calledBy === 'minicart' || carouselTitle) {
                    window['AB'].DATALAYER.setPageFilterMetaInfo(false);
                } else {
                    window['AB'].DATALAYER.setPageFilterMetaInfo(true);
                }
            }
        }
    }

    private setAnalyticsSNSProdAction(action: string) {
        if (this.configObj?.programType === '1P_SNS') {
            localStorage.setItem('analyticsSNSProdAction', action);
        }
    }

    /**
     * Update cart with input's quantity.
     */
    public updateCart(): void {
        if (this.updateState.input === null) {
            this.updateState.input = 0;
        }

        const preference = this._userInfoService.getPreference()
            ? this._userInfoService.getPreference().toUpperCase()
            : undefined;

        if (preference === 'J4U') {
            if(this.configObj?.appName==='weeklyAd'){
                this.navigateBannerDomainToOpenStoreSlctChange(); 
            } else {
                window['storeFulfillmentModal'].component.setModalDisplayData(2);
            }

        } else {
            // README: wrapping the entire code as anonymous function to pass it as a callback Function
            const updateCartIfSessionValid = () => {
                this.loadingSpinner = true;

                let isAddedToCart = false;
                let isQuantityIncreased = false;
                let isRemovedFromCart = false;
                let isQuantityDecreased = false;

                if (this.calledBy === 'minicart') {

                    if (this.updateState.input > this.product.qty) {
                        if (this.product.qty === 0) {
                            isAddedToCart = true;
                        } else {
                            isQuantityIncreased = true;
                        }
                    } else if (this.updateState.input < this.product.qty) {
                        if (this.updateState.input === 0) {
                            isRemovedFromCart = true;
                        } else {
                            isQuantityDecreased = true;
                        }
                    }
                    this.product.qty = this.updateState.input;

                } else {
                    if (this.updateState.input > this.product.quantity) {
                        if (this.product.quantity === 0) {
                            isAddedToCart = true;
                        } else {
                            isQuantityIncreased = true;
                        }
                    } else if (this.updateState.input < this.product.quantity) {
                        if (this.updateState.input === 0) {
                            isRemovedFromCart = true;
                        } else {
                            isQuantityDecreased = true;
                        }
                    }
                    this.product.quantity = this.updateState.input;
                }

                this.addCart(this.updateState.input);

                // updata analytics data layer
                if (this.calledBy !== 'minicart' || this.updateState.input > 0) {
                    if (window['AB']['DATALAYER']) {
                        if (isAddedToCart) {
                            this.addItemToCartAnalytics = true;
                            this.setAnalyticsSNSProdAction('add-item');
                        } else if (isQuantityIncreased) {
                            this.increaseQuantityAnalytics = true;
                            this.setAnalyticsSNSProdAction('quantity-increase');
                        } else if (isRemovedFromCart) {
                            this.removeItemFromCartAnalytics = true;
                            this.setAnalyticsSNSProdAction('remove-item');
                        } else if (isQuantityDecreased) {
                            this.decreaseQuantityAnalytics = true;
                            this.setAnalyticsSNSProdAction('quantity-decrease');
                        }
                    }
                }

                this.statusAriaLive = 'polite';
                this.statusQuantityUpdate = 'update';
            };

            // README: calling validateSession with a callback function (i.e decreaseCartIfSessionValid) which does check for
            // a valid session and decrease the cart
            if (this._commonService.isGuestUser()) {
                updateCartIfSessionValid();
            } else {
                this._commonService.validateSession(updateCartIfSessionValid);
            }

        }
    }

    /**
     * Show update button with numeric input and hide steppers.
     */
    public showUpdate(): void {

        const preference = this._userInfoService.getPreference()
            ? this._userInfoService.getPreference().toUpperCase()
            : undefined;

        if (preference === 'J4U') {
            if(this.configObj?.appName==='weeklyAd'){
                this.navigateBannerDomainToOpenStoreSlctChange();   
            } else {
                window['storeFulfillmentModal'].component.setModalDisplayData(2);
            }

        } else {

            if (this.calledBy === 'minicart') {
                this.updateState.input = this.product.qty;
            } else {
                this.updateState.input = this.product.quantity;
            }

            this.updateState.show = true;
            this.statusAriaLive = 'polite';
            this.setFocusInsideQtyControl();
        }
    }

    /**
     * Remove product from Past Purchases and send emitter to grid.
     */
    public removePastPurchases(event): void {
        this.loadingSpinner = true;
        this.removePastPurchasesEmitter.emit(event);
        this.statusAriaLive = 'polite';
    }

    /**
     * Update quantity on tab or enter.
     */
    public enterTabKeyDown(event: any): any {
        const e = <KeyboardEvent>event;
        const keyCode = !e.which ? e.keyCode : e.which;

        if (this.updateState.button === 'Update') {
            e.preventDefault();
        }

        if (!(this.updateState.button === 'Add' && keyCode === 9)) {
            this.updateCart();
        }

        this.statusAriaLive = 'polite';
    }

    public qscEnterTabKeyDown() {
        this.qscUpdateAmt();
    }

    public qscUpdateAmt() {
        let currentAmt = (document.querySelector(`#qtyInfoControl_${this.product.id}`) as HTMLInputElement).valueAsNumber;

        if (isNaN(currentAmt)) {
           currentAmt = this.qscQuantity;
        }

        if (currentAmt == 0) {
            this.updateCheckboxEmitter.emit();
            this._isCheckboxChecked = false;
            currentAmt = 1;
        }

        if (this.product.maxPurchaseQty && currentAmt > this.product.maxPurchaseQty) {
            currentAmt = this.product.maxPurchaseQty;
        }

        this.qscQuantity = currentAmt;
        this.setLocalStorageQscQuantity(this.qscQuantity);
        this.statusAriaLive = 'polite';
        this.updateState.show = false;
    }

    /**
     * Input Keydown event. Used to remove e,+,- and period from quantity input.
     */
    public inputKeydown(event: any): any {
        const e = <KeyboardEvent>event;
        const keyCode = !e.which ? e.keyCode : e.which;
        const actionsToAllow = [8, 9, 13, 37, 38, 39, 40, 46];  // backspace, tab, enter, arrows and delete
        const keysToAllow = '0123456789';                       // had to do this because firefox sees 1 as ! and ¡ etc if we use keyCodes


        // Prevent all but numbers, backspace, delete, tab and enter
        if (!(actionsToAllow.includes(keyCode) || keysToAllow.includes(e.key))) {
            e.preventDefault();
        }

        // Prevent double space keystroke adding a decimal/. to input
        if (event.key == ' '){
            const inputField =  (document.querySelector(`#qtyInfoControl_${this.product.id}`) as HTMLInputElement)
            inputField.value = inputField.value.replace(/[^0-9]*/g,'');
        }
    }

    /**
     * Input Keyup event. Used to prevent numbers greater than maxPurchaseQty value.
     */
    public inputKeyup(event: any): any {
        if (this.product.maxPurchaseQty && event.target.value > this.product.maxPurchaseQty) {
            event.preventDefault();
            event.target.value = this.product.maxPurchaseQty;
        }
    }

    /**
     * Quantity Stepper Wrapper Keyup event. Used to show update on Tab.
     */
    public qtyStepperKeyup(event: any): any {
        const e = <KeyboardEvent>event;
        const keyCode = !e.which ? e.keyCode : e.which;

        if (keyCode === 13) {
            if (this._isRegistered()) {
                this.showUpdate();
                this.statusAriaLive = 'polite';
                this.setFocusInsideQtyControl();
            } else {
                this._showSignInModal(this.configObj);
            }
        }
    }

    /**
     * Remove product from miniCart.
     */
    private _removeMiniCart(): void {

        if (this.orderNumber !== '' && this.orderNumber != 0) {
            this.removeMiniCartEmitter.emit(this.product.id);
        } else {
            this.removeMiniCartEmitter.emit(this.product.itemId);
        }

        this.statusAriaLive = 'polite';
    }

    private _cartAPICallV2(quantity, snsInfoChangeObj?: any) {
        const isCartCreated = !this.hasCart;
        const oldCartIdLs = JSON.parse(localStorage.getItem('cartId'));
        this.cartV2Service.addOrUpdateProductQuantity(this.product,
            // Added extra ternary for biaAddAllBtn to avoid checking id property on undefined product.
            this.calledBy == 'biaAddAllBtn' ? '' : this.calledBy === 'minicart' ? this.product.itemId : this.product.id, quantity, this.isBiaAddAll, this.product.sellerId, false, this.snsInfo, this.configObj,
        false, null, this.entryId)
            .subscribe((response) => {
                if (response) {
                    if(this.isQuantityIncreased) {
                        this.showPriceChangeToast(this.isQuantityIncreased, response);
                        this.isQuantityIncreased = false;
                    }
                    if(this.configObj?.programType === '1P_SNS') {
                        this.callSNSSuccessDispatch();
                    } else {
                        this.cartService.refreshCart(response);
                    }
                    const cartName = this.cartV2Service.getCartName(this.configObj?.programType, this.product.sellerId);
                    let singleCartresponse: ICart =  this.cartV2Service.fetchCartDetailsFromResponse(response, cartName);
                    if (singleCartresponse && singleCartresponse['cartId']) {
                        if (singleCartresponse['cartItems']) {
                            if (window['AB']['DATALAYER']) {
                                window['AB']['DATALAYER'].updateCartType(this.calledBy === 'minicart' ? 'mini_cart' : '');
                                window['AB']['DATALAYER'].updateCart(response, this.product, response['isWYSIWYGEnabled']);
                            }

                            this.isWYSIWYGEnabled = singleCartresponse['isWYSIWYGEnabled'];

                            // track product impression
                            this.calledBy == 'biaAddAllBtn'
                                ? this.products.forEach(product => this._commonService.sendSponsoredProductClickEvent(product, 'quantityStepper', 'addToCart'))
                                : this._commonService.sendSponsoredProductClickEvent(this.product, 'quantityStepper', 'addToCart');

                            // make ad relevance call for all products on search page only
                            if ( !this.isCrossSellProductItem && this.enableAdRelevanceTracking) {
                                this._commonService.recordRelevanceImpression(this.product, 'quantityStepper', 'addToCart');
                            }
                            if (this.isPrebookRedirect) {
                                this.redirectToPrebookPage();
                            }

                            this.loadingSpinner = false;

                            const isAdd = isCartCreated, isEdit = !isCartCreated;
                            this.cartId = singleCartresponse['cartId'];

                            if (isAdd) {
                                this._cartIdCreated.next(this.cartId);
                            }

                            singleCartresponse = this.cartV2Service.handleResponseForPendingOrder(singleCartresponse);

                            if (!this.isBiaAddAll) {
                                // Add and Remove checkMark after 1 second
                                this.checkMark = true;
                                setTimeout(() => {
                                    this.checkMark = false;
                                    this.showQtyUpdateBtn = false;
                                    this._setFocusInsideQty();
                                    this._clearStatusAriaMessage();
                                }, 1000);

                                this.updateState = {
                                    show: false,
                                    button: 'Update'
                                };
                                this._setFocusInsideQty();

                                this.product.quantity = quantity;
                                this.quantityMessage = this._getQuantityMessage();

                                if (this.calledBy === 'minicart') {
                                    this.changeMiniCartEmitter.emit(singleCartresponse['summary']);
                                    this.updateUnavailableCountEmitter.emit(singleCartresponse['mfcUnavailableProductsCount']);

                                    if (isEdit) {
                                        this.onQtyUpdate.emit(this.product);
                                    }
                                }
                                if (this.product.sellerId && this.configObj?.programType!=='mkp-carousel') {
                                    this.showMkpAddToCartModal(this.product.sellerId, this.product.sellerName, this.product.price, oldCartIdLs);
                                } else if (this.configObj?.programType === 'wineshop') {
                                    this.showStaticFirstTimeCartModal('1P_WINE', oldCartIdLs);
                                }

                                if(this.isOnProductDetail && snsInfoChangeObj &&
                                    (snsInfoChangeObj?.currentValue?.isChecked !== snsInfoChangeObj?.previousValue?.isChecked) &&
                                    snsInfoChangeObj?.currentValue?.isChecked  === false
                                    ) {
                                    this.preventFocusOnQty = true; 
                                    this.toasterService.show({
                                      title: 'OK',
                                      message: `You've unsubscribed to this item.`,
                                      type: ToasterType.Info,
                                      interactiveElement: 'Undo',
                                      autoCloseTime: 30000,
                                      isSnsCheckbox: !(snsInfoChangeObj?.currentValue?.isChecked),
                                      prevIdToFocus: '.checkbox__input'
                                    }, { top: this.toastMessagePostion});
                                }
                            } else {
                                this.disableAddAll = true;
                                // this.toasterService.show({
                                //     title: 'OK',
                                //     message: this.addAllProductsMessage,
                                //     type: ToasterType.Success,
                                //     calledBy: 'quantity-stepper-v3'
                                // }, {top: this.toastMessagePostion});
                            }

                            // Need to check if called by biaAddAllBtn, or else will result accessing undefined product var.
                            // Analytics already updated by addAllItemsMap
                            if (this.calledBy != 'biaAddAllBtn') {
                                if (window['AB']['DATALAYER']) {
                                    const sellerId = this.product.sellerId ? this.product.sellerId : singleCartresponse['cartCategory'] === '1P_WINE' ? '22222222' : window['AB']['DATALAYER'].getBannerSellerId();
                                    this._updateAnalyticsProductInfo(sellerId);
                                    if (this.addItemToCartAnalytics) {
                                        window['AB']['DATALAYER'].addItemToCart();
                                        this.addItemToCartAnalytics = false;
                                    } else if (this.increaseQuantityAnalytics) {
                                        window['AB']['DATALAYER'].increaseItemQuantity();
                                        this.increaseQuantityAnalytics = false;
                                    } else if (this.decreaseQuantityAnalytics) {
                                        window['AB']['DATALAYER'].decreaseItemQuantity();
                                        this.decreaseQuantityAnalytics = false;
                                    }
                                }
                            }

                            //<-- we dont need to update store id here, so commenting this for now -->
                            // if (isEdit) {
                                // @todo verify if this is needed cart and checkout
                                // this.cartV2Service.checkAndUpdateStoreId(singleCartresponse, this.sellerId);
                            // }

                        }
                    }
                }
            }, err => {
                console.error('Error while calling Cart API: ' + err.message);
                if(this.isOnProductDetail && snsInfoChangeObj &&
                    (snsInfoChangeObj?.currentValue?.isChecked !== snsInfoChangeObj?.previousValue?.isChecked) 
                    ) {
                   const modalDataConfig = {
                        modal: 'errorModal',
                        showModal: true,
                        prevIdToFocus: '',
                        errModalType: snsInfoChangeObj.currentValue.isChecked ? 'subscribe' :  'unsubscribe',
                        selectedFrequency :this.snsInfo.selectedFrequency
                    }
                    this._productSnsModalService.show(modalDataConfig);
                }
                this.showQtyUpdateBtn = false;
                this.loadingSpinner = false;
                this.isQuantityIncreased = false;
                if (!this.isBiaAddAll) {
                    this.quantityMessage = this._getQuantityMessage(this.product['originalQuantity']);
                }
            });
    }
    /**
     * Change quantity message with new product quantity.
     *
     * @returns {string} New quantity message to be bind in quantity input's value.
     */
    private _getQuantityMessage(quantity?: number): any {

        this.product.qty = this.product.maxPurchaseQty && quantity > this.product.maxPurchaseQty
            ? this.product.maxPurchaseQty : quantity > 0
                ? quantity : this.product.qty;

        if (this.calledBy === 'minicart') {

            if (this.product.maxPurchaseQty && this.product.qty >= this.product.maxPurchaseQty) {
                return this.isV2CarouselItem || this.isV2ProductItem ? this.product.qty : this.product.qty + ' max';
            }

            // README: set aria label for specify-quantity-counter
            this.quantityAriaLabelMessage = this.product.qty > 1
                ? this.product.qty + ' units of ' + this.product.name + '  in cart. Click to update'
                : this.product.qty + ' unit of ' + this.product.name + '  in cart. Click to update';

            this.adaCartUpdateMessage('Cart updated. ' + this.product.qty + ' in cart');

            return this.isV2CarouselItem || this.isV2ProductItem ? this.product.qty : this.product.qty + ' in Cart';

        } else {

            if (this.product.maxPurchaseQty && this.product.quantity >= this.product.maxPurchaseQty) {
                return this.isV2CarouselItem || this.isV2ProductItem ? this.product.quantity : this.product.quantity + ' max';
            }

            // README: set aria label for specify-quantity-counter
            this.quantityAriaLabelMessage =
                this.product.quantity > 1
                    ? this.product.quantity + ' units of ' + this.product.name + '  in cart. Click to update'
                    : this.product.quantity + ' unit of ' + this.product.name + '  in cart. Click to update';

            this.adaCartUpdateMessage('Cart updated. ' + this.product.qty + ' in cart');

            const message = this.isBIA ? '' : ' in Cart';

            return this.isV2CarouselItem || this.isV2ProductItem || this.componentInfo === 'sticky-pdp'
                ? this.product.quantity : this.product.quantity + message;

        }
    }

    /**
     * Gets desired product in cart quantity from Localstorage.
     *
     * @param {string} productBPN Product unique BPN.
     */
    private _getQuantityInCart(productBPN: string): number {

        try {
            const Cart: any = JSON.parse(localStorage.getItem(this.cartLSname));
            const qty: number = Cart.cartItems.find(item => item.id == productBPN).quantity;

            return (qty > 0) ? qty : 0;

        } catch (e) {
            return 0;
        }
    }

    /**
     * Check if user is registered and may add products in cart.
     */
    private _isRegistered(): boolean {
        return (this._utilService.isTokenActive() && this._userInfoService.isAuthorized());
    }

    /**
     * Show sign in modal to unregistered users.
     */
    private _showSignInModal(configObj?: IConfigObj): void {
        const redirectPath = encodeURIComponent(window.location.href);
        window['SWY'].CONFIGSERVICE.setCookie('ECommRedirectURL', redirectPath, 0);
        if(configObj && configObj?.appName==='weeklyAd'){
            const bannerDomainUrl = this._productUtilService.getBannerDomainUrl(this.configObj);
            const navPath = bannerDomainUrl + window['AB'].signInLinkPath;
            const analyticsIcmpid = window['AB'] && window['AB']['DATALAYER'] && window['AB']['DATALAYER'].trackWeeklyAdIcmpid && window['AB']['DATALAYER'].trackWeeklyAdIcmpid('sign-in-to-add', navPath) || '';
            window.location.assign(navPath + `${analyticsIcmpid}`);
        } else {
            window['AB']['COMMON'].showSignInModal_OTP(window.location.href);
        }
    }

    /**
     * Removes text from aria-live announcement.
     */
    private _clearStatusAriaMessage(): void {
        this.statusAddAriaMessage = '';
    }

    /**
     * ADA: Sets focus inside quantity stepper with info about in cart quantity.
     */
    private _setFocusInsideQty(): void {

        if (this.calledBy === 'minicart') {
            setTimeout(() => $('#qtyMiniCartInfo_' + this.product.itemId).focus(), 0);

        } else if (this.calledBy === 'minicart') {
            setTimeout(() => $('#qtyMiniCartInfo_' + this.product.id).focus(), 0);

        } else {
            if(!this.preventFocusOnQty){
                setTimeout(() => $(this._elementRef.nativeElement).children().find("span#qtyInfo_" + this.product.id).focus(), 0);
            }
        }
    }

    private setFocusInsideQtyControl(): void {
        setTimeout(() => {
            if (this.calledBy === 'minicart') {
                $('#qtyInfoControl_' + this.product.itemId).focus();
                $('#qtyInfoControl_' + this.product.itemId).select();
            } else {
                $('#qtyInfoControl_' + this.product.id).focus();
                $('#qtyInfoControl_' + this.product.id).select();
            }
        }, 150);
    }

    private _removeProductV2() {
        this.cartV2Service.removeProduct(
            this.product,
            this.calledBy === 'minicart' ? this.product.itemId : this.product.id,
            this.product.sellerId, this.configObj, false, this.entryId
        ).subscribe((response: any) => {
            if(response) {
                if(this.configObj?.programType === '1P_SNS') {
                    this.callSNSSuccessDispatch();
                } else {
                    this.cartService.refreshCart(response);
                }
                const cartName = this.cartV2Service.getCartName(this.configObj?.programType, this.product.sellerId);
                let singleCartresponse :ICart=  this.cartV2Service.fetchCartDetailsFromResponse(response, cartName);
                

                if (window['AB']['DATALAYER']) {
                    const sellerId = this.product.sellerId ? this.product.sellerId : singleCartresponse['cartCategory'] === '1P_WINE' || cartName === '1P_WINE' ? '22222222' : window['AB']['DATALAYER'].getBannerSellerId();
                    this._updateAnalyticsProductInfo(sellerId);
                    window['AB']['DATALAYER'].updateCartType(this.calledBy === 'minicart' ? 'mini_cart' : '');
                    window['AB']['DATALAYER'].updateCart(response, null, response['isWYSIWYGEnabled']);
                    if (this.removeItemFromCartAnalytics) {
                        window['AB']['DATALAYER'].removeItemFromCart();
                        this.removeItemFromCartAnalytics = false;
                    }
                }

                if (!this.isBiaAddAll) {
                    this._commonService.sendSponsoredProductClickEvent(this.product, 'quantityStepper', 'removeProduct');
                }

                singleCartresponse = this.cartV2Service.handleResponseForPendingOrder(singleCartresponse);

                this.loadingSpinner = false;

                // Add and Remove checkMark after 1 second
                this.checkMark = true;
                setTimeout(() => {
                    this.checkMark = false;
                    this.showQtyUpdateBtn = false;
                    this._setFocusInsideQty();
                    this._clearStatusAriaMessage();
                }, 1000);

                this.updateState = {
                    show: false,
                    button: 'Update'
                };
                this._setFocusInsideQty();

                // Emit new cart summary to minicart
                if (this.calledBy === 'minicart') {
                    this.changeMiniCartEmitter.emit(singleCartresponse['summary']);
                    this.updateUnavailableCountEmitter.emit(singleCartresponse['mfcUnavailableProductsCount']);
                }

                this.isWYSIWYGEnabled = singleCartresponse['isWYSIWYGEnabled'];
            }
        }, err => {
            console.error('Error while calling Cart API: ' + err.message);
            this.showQtyUpdateBtn = false;
            this.loadingSpinner = false;
            this.quantityMessage = this._getQuantityMessage(this.product['originalQuantity']);
        });
    }

    /**
     * Updates products to be added to cart when customer uses the buy it again
     * add all items to cart button
     **/
    private updateBiaAddAllBtnContext() {
        this.allProductsToAdd = this.calcAddAllProducts(this.products);
        //README: Sets this.noOfProductsToAdd to original products length if all products have been added. Disables add all button while displaying
        //original products length to inform customer all items have been added to cart.
        this.noOfProductsToAdd = this.allProductsToAdd.length === 0 ? this.products.length : this.allProductsToAdd.length;
        this.disableAddAll = this.allProductsToAdd.length === 0 ? true : false;
    }

    //Returns array of objects. The objects containing itemId and qty
    private addAllItemsMap() {
        console.warn('addAllItemsMap()');
        this.addAllProductsMessage = this.noOfProductsToAdd == 1 ? `1 item added to cart` : `${this.noOfProductsToAdd} items added to cart`;
        this.analyticsAddAllItems(this.allProductsToAdd);
        return this.allProductsToAdd.map(product => {
            return {
                itemId: product.id,
                qty: 1
            };
        });
    }

    //Returns array of all products to be added to cart after filtering for products already in cart
    private calcAddAllProducts(products) {
        const cartObj = this.cartService._get();

        const cartItemsMap = cartObj['cartItems'] ? cartObj['cartItems'].map(cartItem => {
            return cartItem.itemId;
        }) : [];

        //check if the product has price > 0 & is not in cart already
        function shouldAddProduct(prod) {
            let isInCart = false;
            for (const cartItem in cartItemsMap) {
                if (cartItemsMap[cartItem] == prod.id) {
                    isInCart = true;
                }
            }

            return (prod.price > 0 && isInCart == false);
        }

        return products.filter(shouldAddProduct);
    }

    private addAllItemsToCart(items) {
        console.warn('addAllItemsToCart()')
        this._cartAPICallV2(items);
    }

    /**
     * ADA message for announcing cart update
     *
     */
    public adaCartUpdateMessage(message: string) {
        this.quantityAdaMessage = message;
        setTimeout(() => {
            this.quantityAdaMessage = '';
        }, 100);
    }

    public updateLoadingMessage(qty) {
        this.stepperAnnouncement = `quantity content ${qty} loading`;
    }

    /**
     * Adds a product to cart
     *
     */
    public addToCart() {
        if (this.isAuthorized) {
            const showMTOModalIfSessionValid = () => {
                if (this.product.isMtoProduct) {
                    if (window['AB']['COMMON'].checkPendingOrder()) {
                        const abSlotEditOrder = 'abSlotEditOrder';
                        const error = 'error';
                        if (localStorage.getItem(abSlotEditOrder)) {
                            if (this._commonService.preparationTimeExceedsPrebook(this.product, abSlotEditOrder) 
                                && !this._commonService.byPassReserveSlotCheck(this.product)) {
                                this._displayMtoModal(error, '#mtoModalError', {show: true, backdrop: false});
                            } else {
                                this.beforeIncreaseCart(this.crossSellEnabled);
                            }
                        } else {
                            this._displayMtoModal(error, '#mtoModalError', {show: true, backdrop: false});
                        }
                    } else {
                        const abSlot = 'abSlot';
                        if (localStorage.getItem(abSlot)) {
                            if (this._commonService.preparationTimeExceedsPrebook(this.product, abSlot)
                                && !this._commonService.byPassReserveSlotCheck(this.product)) {
                                this._displayMtoModal('popup', '#mtoModal', {show: true});
                            } else {
                                this.beforeIncreaseCart(this.crossSellEnabled);
                            }
                        } else {
                            this.beforeIncreaseCart(this.crossSellEnabled);
                        }
                    }
                } else {
                    this.beforeIncreaseCart(this.crossSellEnabled);
                }
            };

            this._commonService.validateSession(showMTOModalIfSessionValid);
        } else {
            this.beforeIncreaseCart(this.crossSellEnabled);
        }
    }

    /**
     * Analytics method for tracking link clicks on MTO modal
     *
     */
    public analyticsMTOClicks(linkClicked) {
        if (window['AB'] && window['AB']['DATALAYER']) {
            window['AB']['DATALAYER'].setModalClickEvents(`mto-pickup|${linkClicked}`);
        }
    }

    /**
     * Triggers a separate analytics call for each of the products added to cart
     * @param items  - items added to cart in bulk
     */
    public analyticsAddAllItems(items) {
        if (window['AB'] && window['AB']['DATALAYER']) {
            window['AB']['DATALAYER'].addAllBIAItemsToCart(items, 'qs-component', this.cartId, this.calledBy);
        }
    }

    /**
     * Reserve new time button handle for MTO modal
     *
     */
    public reserveNewTime() {
        if (window['AB']['COMMON'].isLSCompatible()) {
            const abSlot = JSON.parse(localStorage.getItem('abSlot'));
            const slotId = abSlot?.slotId;
            const slotType = abSlot?.type;

            if (slotId) {
                const delRequest = this._deleteSlotRequest(slotId, slotType);

                const selectorModal = '#mtoModal';
                // README: Delete current prebooked slot
                this._http.delete(delRequest.url,
                    {headers: new HttpHeaders(delRequest.headers), responseType: 'text' as const}).subscribe((data) => {

                    if (this._aemService.isLSCompatible()) {
                        localStorage.removeItem('abSlot');
                    }
                    // README: Resets reserve nav messsage after the slot is deleted
                    this._resetReserveNavText();

                    // README: Add item to cart
                    this.beforeIncreaseCart(this.crossSellEnabled, true);

                }, (err) => {
                    // README: Close MTO modal
                    $(selectorModal).modal('hide');
                });
            }
        }
    }

    /**
     * Redirect to prebook page
     */
    private redirectToPrebookPage() {
        const prebookPageRedirect = `${document.location.origin}/erums/store/prebook`;
        window.location.href = prebookPageRedirect;
    }

    /**
     * Choose time later button handle for MTO modal
     *
     */
    public chooseTimeLater() {
        if (window['AB']['COMMON'].isLSCompatible()) {
            const abSlot = JSON.parse(localStorage.getItem('abSlot'));
            const slotId = abSlot?.slotId;
            const slotType = abSlot?.type;

            if (slotId) {
                const delRequest = this._deleteSlotRequest(slotId, slotType);

                const selectorModal = '#mtoModal';
                // README: Delete current prebooked slot
                this._http.delete(delRequest.url,
                    {headers: new HttpHeaders(delRequest.headers), responseType: 'text' as const}).subscribe((data) => {

                    if (window['AB'].COMMON.isLSCompatible()) {
                        localStorage.removeItem('abSlot');
                    }
                    // README: Resets reserve nav messsage after the slot is deleted
                    this._resetReserveNavText();

                    // README: Add item to cart
                    this.beforeIncreaseCart(this.crossSellEnabled, false);

                    // README: Close MTO modal
                    $(selectorModal).modal('hide');
                }, (err) => {
                    // README: Close MTO modal
                    $(selectorModal).modal('hide');
                });
            }
        }
    }

    /**
     * Constructs the request for prebook delete slot
     *
     */
    private _deleteSlotRequest(slotId, slotType) {
        const origin = window.location.origin;
        const storeId = window['AB'].userInfo.branchId;
        const userChannel = this._userInfoService.getUserChannel() ? this._userInfoService.getUserChannel().toUpperCase() : '';

        // isReservationServiceEnabled (default false): true -> reservation service endpoint, false -> slot promise service endpoint
        const isReservationServiceEnabled = window['SWY'].CONFIGSERVICE.featureToggleConfig?.isReservationServiceEnabled === true;
        let path = window['SWY'].CONFIGSERVICE.osdpConfig[isReservationServiceEnabled ? 'osdp.reservation.service.endpoint' : 'osdp.slot.promise.service.endpoint'];
        const headers = window['AB'].ecommHttpOptionsOsdp;
        headers.clientId = 'CC';
        headers.storeId = storeId;
        // update path if mockinator is requested
        const wiremockAPIDetails = this.config[this.currentEnv].wiremockAPIDetails;
        // check if wiremock service is enabled
        if (wiremockAPIDetails?.allowWiremockService) {
            const mode = this._utilService.getParams('mode');
            // check mode coming from request parameter
            if (mode === 'record') {
                // prepend record base url to virtual shelf api endpoint
                path = `${wiremockAPIDetails?.recorderBaseUrl}${path}`;
            } else if (mode === 'playback') {
                // prepend playback base url to virtual shelf api endpoint
                path = `${wiremockAPIDetails?.playbackBaseUrl}${path}`;
            }
            // update subscription key with mockinator subscription key if mode is either playback or record
            headers['ocp-apim-subscription-key'] = (mode === 'record' || mode === 'playback') ? wiremockAPIDetails?.subscriptionKey : headers['ocp-apim-subscription-key'];
        }
        if (userChannel && (userChannel === 'DELIVERY' || userChannel === 'PICKUP')) {
            if (userChannel === 'PICKUP') {
                headers['serviceType'] = 'DUG';
            } else {
                headers['serviceType'] = userChannel;
            }
        }

        let slotTypeParameter = '';
        if (slotType === 'FLASH')
            slotTypeParameter = '?type=FLASH';

        return {
            url: `${origin}${path}/reserve/${storeId}/${slotId}${slotTypeParameter}`,
            headers: headers
        };
    }

    /**
     * Resets reserve nav text after the slot has been deleted
     */
    private _resetReserveNavText() {
        if (window['AB'].userInfo.preferenceMode.toLowerCase() === 'dug') {
            const reserveNav = document.querySelector('.reserve-nav__text_pickup');
            if (reserveNav) {
                reserveNav.textContent = 'Reserve a pickup time';
            }
        } else if (window['AB'].userInfo.preferenceMode.toLowerCase() === 'delivery') {
            const reserveNav = document.querySelector('.reserve-nav__text_delivery');
            if (reserveNav) {
                reserveNav.textContent = 'Reserve a delivery time';
            }
        }
    }

    /**
     * Dispalys the MTO Modal
     *
     * @param modalType - can be popup or error modal
     *
     * @param modalId - id of the modal
     *
     * @param modalOptions - options for jQuery modal()
     *
     */
    private _displayMtoModal(modalType, modalId, modalOptions) {
        this.mto[modalType].show = true;
        setTimeout(() => {
            $(modalId).modal(modalOptions);
            $(modalId).appendTo('.unified-footer');
            const qtyStepper = this;
            $(modalId).on('shown.bs.modal', function () {
                qtyStepper.mtoShowADA(modalType);
            });
            $(modalId).on('hidden.bs.modal', function () {
                qtyStepper.mto[modalType].show = false;
                $(modalId).remove();
                qtyStepper.mtoHideADA(modalType);
            });
            window['AB']?.DATALAYER?.setModalViewEvents('mto-pickup|view');
        }, 100);
    }

    /**
     * Sets ADA functionality when showing MTO modal
     *
     * @param modalType the type of the modal: popup or error
     */
    private mtoShowADA(modalType) {
        const closeBtn = this.mto[modalType].closeBtn;
        const modalId = this.mto[modalType].modalId;
        const first = this.mto[modalType].firstFocusableElem;
        const last = this.mto[modalType].lastFocusableElem;

        $(closeBtn).focus();
        $('.root').children().children(':nth-child(1)').attr('aria-hidden', true);
        $('.root').children().children(':nth-child(2)').attr('aria-hidden', true);
        $('.unified-footer').siblings().attr('aria-hidden', true);
        $('.unified-footer').children().attr('aria-hidden', true);
        $(modalId).attr('aria-hidden', false);

        $(last).on('keydown keypress', function (e) {
            if ($('this:focus') && e.which === 9) {
                if (first === last) {
                    e.preventDefault();
                } else if (!e.shiftKey) {
                    $(first).focus();
                }
            }
        });
    }

    /**
     * Sets ADA functionality when hidding MTO modal
     *
     * @param modalType the type of the modal: popup or error
     */
    private mtoHideADA(modalType) {
        const closeBtn = this.mto[modalType].closeBtn;
        const qtyStepper = this;

        $(closeBtn).focus();
        $('.root').children().children(':nth-child(1)').removeAttr('aria-hidden');
        $('.root').children().children(':nth-child(2)').removeAttr('aria-hidden');
        $('.unified-footer').siblings().removeAttr('aria-hidden');
        $('.unified-footer').children().removeAttr('aria-hidden');
        $(`#addButton_${qtyStepper.product.id}`).focus();
    }

    /**
     * Triggers MKP Add to cart Modal when user adding seller Product for first time
     * Checks cartId local storage to determine the cart seller cart activity
     * Replaces modal placeholders with order min and product price
     * **/
    public showMkpAddToCartModal(sellerId, sellerName, productPrice, cartIdLs) {
        if (cartIdLs && cartIdLs[sellerId]) {
            return;
        } else {
            this.showDynamicFirstTimeCartModal(sellerId, sellerName, productPrice);
        }
    }

    /**
    * This function shows the first time cart modal authored version (static).
    */
    public showStaticFirstTimeCartModal(cartId, cartIdLs) {
        const cartModalId = '#addToCartModal-' + this.configObj?.programType;
        if (cartIdLs && cartIdLs[cartId]) {
            return;
        } else {
            window['ErrorStateModalComp'].triggerEmptyStateModal(cartModalId, true);
            if (window['AB'] && window['AB'].DATALAYER) {
                window['AB'].DATALAYER.addedToSellerTypeModalTracking('wineshop');
            }
        }
    }

    /**
    * This function shows the first time cart modal api driven version (dynamic).
    */
    private showDynamicFirstTimeCartModal(sellerId, sellerName, productPrice) {
        // generate add to cart modal based on program type
        const cartModalId = '#addToCartModal-' + this.configObj?.programType;
        const cartModal = $(cartModalId);

        // replace sellerId and sellerName in image url and alt text and set src and alt text
        const mkpLogo = $(cartModalId + ' .error-state-modal__logo img');

        const mkpLogoPlaceholder = mkpLogo.attr('data-image-placeholder');
        const mkpAltPlaceholder = mkpLogo.attr('data-alt-placeholder');
        mkpLogo.attr('src', mkpLogoPlaceholder?.replace('(sellerId)', sellerId));
        mkpLogo.attr('alt', mkpAltPlaceholder?.replace('(sellerName)', sellerName));

        // replace sellerName placeholder in modal title and set inner html
        const modalSellerCartTitle = $(cartModalId + ' .error-state-modal__title');
        const messagePlaceholder = modalSellerCartTitle.attr('data-message-placeholder');
        const modalTitleHtml = messagePlaceholder?.replace('(sellerName)', sellerName);
        // update element html with replaced value
        modalSellerCartTitle?.html(modalTitleHtml);
        cartModal.attr("aria-label",modalTitleHtml);

        // calculate if current product price is > order minimum and replace current price and order minimum placeholder
        const mkpOrderMinModalMessage = $(cartModalId + ' .error-state-modal__shipping-text');
        const noOrderMinElem = $(cartModalId + ' .error-state-modal__noOrderMin');
        const mkpOrderMinModalMessage_cp = $(cartModalId + ' .error-state-modal__shipping-text .error-state-modal__shipping-text__cp');
        // add to cart Minimum order price class
        const mkpOrderMinModalMessage_mo = $(cartModalId + ' .error-state-modal__shipping-text .error-state-modal__shipping-text__mo');
        // get mkpShipping local storage to get the shipping details
        const mkpSellerShippingInfo = JSON.parse(localStorage.getItem('mkpShipping'));
        // check if shipping info is available in local storage else return

        if(mkpSellerShippingInfo && mkpSellerShippingInfo['shippingInfo'][sellerId]) {
            const domesticShippingFreeThreshold = mkpSellerShippingInfo['shippingInfo'][sellerId].domesticShippingFreeThreshold;
            const shippingFee = mkpSellerShippingInfo['shippingInfo'][sellerId].shippingFee;
            const modalShippingText = $(cartModalId + ' .error-state-modal__text');
            const qualifyFreeShipping = $(cartModalId + ' .error-state-modal__qualifyFreeShipping');
            const domesticFreeShipping = $(cartModalId + ' .error-state-modal__domesticFreeShipping');

            /**
             * if domestic free shipping threshold > 0 and shipping fee > 0
             * Show free shipping message if threshold is > product price else fall back to min cart threshold
             * */
            if (domesticShippingFreeThreshold > 0 && shippingFee > 0) {
                const mkpOrderMinModalMessage_cp = $(cartModalId + ' .error-state-modal__domesticFreeShipping .error-state-modal__shipping-text__cp');
                if(domesticShippingFreeThreshold > productPrice) {
                    mkpOrderMinModalMessage_cp.html('$' + ((domesticShippingFreeThreshold - productPrice).toFixed(2)).toString());
                    domesticFreeShipping.removeClass('d-none');
                    mkpOrderMinModalMessage.addClass('d-none');
                    modalShippingText.removeClass('d-none')
                    qualifyFreeShipping.addClass('d-none');
                } else {
                    qualifyFreeShipping.removeClass('d-none')
                    domesticFreeShipping.addClass('d-none');
                    mkpOrderMinModalMessage.addClass('d-none');
                }
            } else {
                const orderMin = mkpSellerShippingInfo['shippingInfo'][sellerId].minCartThresholdValue;
                if (orderMin && orderMin > 0 && orderMin > productPrice) {
                    // calculate order min from min threshold and round off
                    mkpOrderMinModalMessage_cp.html('$' + ((orderMin - productPrice).toFixed(2)).toString());
                    // update order minimum value with actual value from MKP Shipping LS
                    mkpOrderMinModalMessage_mo.html('$' + orderMin.toString());
                    noOrderMinElem.addClass('d-none');
                    mkpOrderMinModalMessage.removeClass('d-none');
                    qualifyFreeShipping.addClass('d-none');
                    domesticFreeShipping.addClass('d-none');
                } else if (orderMin === 0) {
                    // if order minimum is 0 then show no order minimum element
                    mkpOrderMinModalMessage.addClass('d-none');
                    noOrderMinElem.removeClass('d-none');
                    qualifyFreeShipping.addClass('d-none');
                    domesticFreeShipping.addClass('d-none');
                } else {
                    // above conditions fails then hide order minum elements
                    mkpOrderMinModalMessage.addClass('d-none');
                    noOrderMinElem.addClass('d-none');
                }
            }

            // Shipping fee elements
            const shippingFeeElem = $(cartModalId + ' .error-state-modal__text__shipping');
            const freeShippingElem = $(cartModalId + ' .error-state-modal__freeShipping');

            // if shipping fee > 0 then update html with shipping fee else remove shipping html from DOM
            /**
             * Check if domestic free shipping flag is enabled and
             * if domestic free shipping is > 0 product price is less than threshold then show shipping fee
             * else hide
             * */
             if (shippingFee && shippingFee > 0 && (domesticShippingFreeThreshold > 0 && domesticShippingFreeThreshold > productPrice || domesticShippingFreeThreshold < 1)) {
                shippingFeeElem?.html('$' + shippingFee);
                freeShippingElem.addClass('d-none');
                modalShippingText.removeClass('d-none');
            } else if(shippingFee === 0) {
                modalShippingText.addClass('d-none');
                freeShippingElem.removeClass('d-none');
            }
            else {
                modalShippingText?.addClass('d-none');
                freeShippingElem?.addClass('d-none');
            }
            if($('.main-wrapper').attr('data-custom-page-type') === 'mkp-cross-seller-page'){
                $(".modal-footer__action-btn__cart").html('Go to Seller');
                const goToSeller = $(cartModalId + ' .modal-footer__action-btn__cart');
                goToSeller.attr('seller-url', this._commonService.getSellerLandingPath(sellerId));
            }

            this.updateSrMsgs(cartModalId);

        } else {
            console.warn('mkpShipping local storage missing or current seller shipping info is not available');
        }
        window['ErrorStateModalComp'].triggerEmptyStateModal(cartModalId, true);
        if (window['AB'] && window['AB'].DATALAYER) {
            window['AB'].DATALAYER.addedToSellerTypeModalTracking('marketplace');
        }
    }

    // To make ADA read the message as a whole instead of span by span
    private updateSrMsgs(cartModalId){
        const minOrderShippingContent = $(cartModalId + ' .error-state-modal__shipping-text-content').text();
        const domesticFreeShippingContent = $(cartModalId + ' .error-state-modal__domesticFreeShipping-content').text();
        const qualifyFreeShippingContent = $(cartModalId + ' .error-state-modal__qualifyFreeShipping-content').text();
        const shippingTextContent = $(cartModalId + ' .error-state-modal__text-content').text();

        $(cartModalId + ' .error-state-modal__shipping-text-sr').text(minOrderShippingContent);
        $(cartModalId + ' .error-state-modal__domesticFreeShipping-sr').text(domesticFreeShippingContent);
        $(cartModalId + ' .error-state-modal__qualifyFreeShipping-sr').text(qualifyFreeShippingContent);
        $(cartModalId + ' .error-state-modal__text-sr').text(shippingTextContent);
    }

    /**
    * This function adds shown and hidden listeners to first time cart modal.
    */
    private addFirstTimeCartModalListeners() {
        const $this = this;
        const cartModalId = '#addToCartModal-' + this.configObj?.programType;
        const closeButtonClass = ' .error-state-modal__header__modal-close';

        // after opening add to cart modal, set focus on close button
        $(cartModalId).on('shown.bs.modal', function () {
            setTimeout(() => {
                $(cartModalId + closeButtonClass).focus();
            }, 1000);
        });
        $(cartModalId).on('hidden.bs.modal', function () {
            setTimeout(() => {
                $this._setFocusInsideQty();
            }, 1000);
        })
    }

    public onQscStepperClick() {
        if (window['AB']['COMMON'].getUserChannel() == 'instore') {
            window['rightDrawerComp'].closeDrawer();
            window['storeFulfillmentModal'].component.setModalDisplayData(2);
            return;
        }

        if (!this._isCheckboxChecked) {
            return;
        }

        this.isQuantityStepperExtended = true;
    }

    public qscIncrease() {
        if (this.qscQuantity == this.product?.maxPurchaseQty) {
            return
        }
        this.qscQuantity += 1;

        this.setLocalStorageQscQuantity(this.qscQuantity);
    }

    public qscDecrease() {
        // Uncheck checkbox, make quantity-stepper disabled.
        if (this.qscQuantity == 1) {
            this.updateCheckboxEmitter.emit(false);
            return;
        }
        this.qscQuantity -= 1;
        this.setLocalStorageQscQuantity(this.qscQuantity);
    }

    public onQscAmtClick() {
        if (!this.isQuantityStepperExtended) {
            return;
        }

        this.updateState.input = this.qscQuantity;
        this.updateState.show = true;
        this.statusAriaLive = 'polite';
        this.setFocusInsideQtyControl();
    }

    public setLocalStorageQscQuantity(amount: number) {
        if (this.product.maxPurchaseQty && amount > this.product.maxPurchaseQty) {
            amount = this.product.maxPurchaseQty;
        }
        this._quickAddBasketService.setQuickAddBasketItemQuantity(this.product.id, amount);
    }

    /**
     * This function is called on cart api success when program type is 1P_SNS
    */

     callSNSSuccessDispatch() {
        const payloadData = {
            'data-bpn': this.product.id,
            'qty': this.product.quantity
        }
        this._commonService.dispatchCustomOneTimeEvent('snsOneTime', 'productQtyUpdateSuccess', payloadData);
    }

    ngOnDestroy() {
        if (this.updateBiaAddAllSubscription) {
            this.updateBiaAddAllSubscription.unsubscribe();
        }

        if (this.subscriptions) {
            this.subscriptions.unsubscribe();
        }
    }

    /**
     * This method return MTO Product Preparation Popup Text
     * @returns String mtoPopupText
     */
    public getMtoPopupText(): string{
        return `${this.product.mtoDisplyableTime}`;
    }

    /**
     * Navigate Domain Banner to open 2 modal store selection
     */
    private navigateBannerDomainToOpenStoreSlctChange(){
        const bannerDomainUrl = this._productUtilService.getBannerDomainUrl(this.configObj);
        const generatedTargetUrl = bannerDomainUrl + "/home.html?action=changeStore&goto=" + encodeURIComponent(window.location.href)+"&modaltype=2";
        window.location.href = generatedTargetUrl;
    }
}


